import styles from "./styles.module.scss";

import { StatusTagColors } from "../../constants";
import { StatusTagProps } from "./types";
import { capitalize } from "lodash";
import { Tooltip } from "@altimateai/lego";
import OpportunityStatusTooltip from "@/modules/insights/components/OpportunityStatusTooltip";

const StatusTag = ({ status }: StatusTagProps) => {
  return (
    <Tooltip title={<OpportunityStatusTooltip assignedStatus={status} />}>
      <div
        className={styles.statusTag}
        style={{
          backgroundColor: StatusTagColors[status as keyof typeof StatusTagColors].color,
          color: StatusTagColors[status as keyof typeof StatusTagColors].textColor,
        }}
      >
        {capitalize(status)}
      </div>
    </Tooltip>
  );
};

export default StatusTag;
